import {
  BadgeDollarSign,
  CalendarClock,
  Dices,
  Flag,
  House,
  PackageOpen,
  ShieldCheck,
  Trophy,
  UsersRound,
  UserRound,
} from "lucide-react";

import type { ThemeV1 } from "@/theme/schema";

export const primaryDestinations = [
  { href: "/app/", label: "Home", icon: House },
  { href: "/app/schedule", label: "Schedule", icon: CalendarClock },
  { href: "/app/packs", label: "Packs", icon: PackageOpen },
  { href: "/app/player", label: "Stable", icon: UserRound },
] as const;

export const worldDestinations = [
  { href: "/app/marketplace", label: "Marketplace", icon: BadgeDollarSign },
  { href: "/app/syndicates", label: "Syndicates", icon: UsersRound },
  {
    href: "/app/leaderboards",
    label: "Leaderboard",
    icon: Trophy,
  },
  { href: "/app/verify", label: "Fairness", icon: ShieldCheck },
] as const;

export const mobileDestinations = [
  ...primaryDestinations,
  worldDestinations[2],
] as const;

export const productIconRegistry = Object.freeze({
  casino: Dices,
  sports: Trophy,
  rips: PackageOpen,
  racing: Flag,
});

export const productIconAssets = Object.freeze({
  casino: "/app/static/themes/monkeytilt/icons/casino.svg",
  sports: "/app/static/themes/monkeytilt/icons/sports.svg",
  rips: "/app/static/themes/monkeytilt/icons/rips.svg",
  racing: null,
});

export function activeFor(location: string, href: string) {
  if (href === "/app/") return location === "/app" || location === "/app/";
  return location.startsWith(href);
}

export function enabledProducts(theme: ThemeV1) {
  return theme.products.filter((product) => product.enabled && product.href);
}
